import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, Users, BookOpen, LogOut, GraduationCap, Send } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { SoundToggle } from "./PushPrompt";

const items = [
  { to: "/", label: "Dashboard", sub: "数据台", icon: LayoutDashboard, tid: "nav-dashboard" },
  { to: "/inbox", label: "Inbox", sub: "收件箱", icon: Inbox, tid: "nav-inbox" },
  { to: "/leads", label: "Leads", sub: "线索", icon: Users, tid: "nav-leads" },
  { to: "/messages", label: "Message Log", sub: "消息记录", icon: Send, tid: "nav-messages" },
  { to: "/knowledge", label: "Knowledge Base", sub: "知识库", icon: BookOpen, tid: "nav-knowledge" },
  { to: "/team", label: "Team", sub: "团队", icon: Users, tid: "nav-team" },
];

export default function Sidebar({ onNavigate }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <aside className="w-64 flex-shrink-0 border-r border-slate-200 bg-white flex flex-col h-screen sticky top-0">
      <div className="px-5 py-6 border-b border-slate-200 flex items-center gap-2.5">
        <div className="w-9 h-9 bg-emerald-700 text-white flex items-center justify-center rounded-sm">
          <GraduationCap size={20} strokeWidth={2.5} />
        </div>
        <div>
          <div className="font-display text-xl font-black tracking-tight leading-none">Edurise</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">Sales CRM</div>
        </div>
      </div>

      <nav className="flex-1 p-3 space-y-1">
        {items.map(({ to, label, sub, icon: Icon, tid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={tid}
            onClick={() => onNavigate && onNavigate()}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 text-sm font-medium transition-colors rounded-sm ${
                isActive
                  ? "bg-emerald-50 text-emerald-800 border-l-2 border-emerald-700"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              }`
            }
          >
            <Icon size={17} strokeWidth={2} />
            <div className="min-w-0 flex-1 leading-tight">
              <div className="truncate">{label}</div>
              {sub && <div className="text-[10px] text-slate-400 font-normal truncate">{sub}</div>}
            </div>
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-slate-200">
        <div className="flex items-center gap-2.5 mb-2 px-2 py-2">
          <div className="w-8 h-8 rounded-full bg-emerald-700 text-white flex items-center justify-center text-xs font-bold">
            {user?.name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold truncate">{user?.name}</div>
            <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          </div>
        </div>
        <SoundToggle />
        <button
          data-testid="logout-btn"
          onClick={() => { logout(); navigate("/login"); }}
          className="w-full flex items-center gap-2 px-3 py-2 text-sm text-slate-600 hover:bg-slate-50 hover:text-red-600 rounded-sm transition-colors"
        >
          <LogOut size={15} /> Sign out
        </button>
      </div>
    </aside>
  );
}
